import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SOTService, VoucherActionType } from '../../services';
import { Subscription } from 'rxjs';
import { PaymentType } from '../../models';

@Component({
  selector: "sot-pager",
  templateUrl: "./pager.component.html",
  styleUrls: ["./pager.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PagerComponent implements OnInit, OnDestroy {

  private _scanPagerSubscription: Subscription;
  public isModeOne: boolean = false;
  public isModeTwo: boolean = false;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) {
  }
  public ngOnInit(): void {
    const me = this;
    me.isModeOne = me._sotService.useModeOne();
    me.isModeTwo = me._sotService.useModeTwo();
    me._scanPagerSubscription = me._sotService.evScanPagerDone.subscribe((success) => {
      if (success) {
        if (me._sotService.voucherSelectedForPay) {
          me._sotService.AddVoucher(VoucherActionType.PayOrCollect, true);
        } else {
          if (me._sotService.GetPayType() === PaymentType.atCard) {
            me._sotService.GoToOrderCardScan();
          } else {
            me._sotService.StartPayment();
          }
        }
      } else {
        me._sotService.OpenPagerCouldNotBeReadDialog(() => {
          me._sotService.SOTConnectionSendScanPager();
        });
      }
    });
    me._sotService.SOTConnectionSendScanPager();
  }

  public ngOnDestroy(): void {
    const me = this;
    if (me._scanPagerSubscription) {
      me._scanPagerSubscription.unsubscribe();
    }
  }

  public back(): void {
    const me = this;
    me._sotService.SOTConnectionSendCancelScanning();
    me._sotService.GoToCheckout();
  }

  public openManualPagerInput(): void {
    const me = this;
    me._sotService.SOTConnectionSendCancelScanning();
    me._sotService.OpenManualPagerInput(() => { });
  }

}
